import { createSlice } from "@reduxjs/toolkit";

export const partnerSlice = createSlice({
    name: "partner",
    initialState: {
        partners: []
    },
    reducers: {
        updatePartners: (state, action) => {
            state.partners = action.payload
        }
    }

})

export const { updatePartners } = partnerSlice.actions;

export default partnerSlice.reducer